<template>
	<component
		:is="template"
		v-bind="page?.meta.templateProps as object"
	>
		<div class="py-20">
			<ContentRenderer
				v-if="page"
				:value="page"
			/>
		</div>
	</component>
</template>

<script setup lang="ts">
import type { TemplateEnum } from '#fit/core/enums/TemplateEnum';

const route = useRoute();

const { data: page } = await useAsyncData(`dynamic-pages-${route.path}`, async () => {
	const result = await queryCollection('content').path(route.path).first();
	if (!result) {
		throw createError({
			statusCode: 404,
			statusMessage: 'Page not found',
		});
	}
	return result;
});

useSeoMeta({
	...page.value?.seo,
	ogTitle: page.value?.title,
});

const getTemplate = (templateName: keyof typeof TemplateEnum) => {
	switch (templateName) {
		case 'Blog':
			return resolveComponent('TemplateBlog');
		case 'Hero':
			return resolveComponent('TemplateHero');
		case 'HeroDiagonal':
			return resolveComponent('TemplateHeroDiagonal');
		case 'Sales':
			return resolveComponent('TemplateSales');
		case 'Slideshow':
			return resolveComponent('TemplateSlideshow');
		default:
			return resolveComponent('TemplateDefault');
	}
};

const template = getTemplate(page.value?.meta.template as keyof typeof TemplateEnum);
</script>
